import { render, staticRenderFns } from "./TipoConsultaEmpresas.vue?vue&type=template&id=71266fde&scoped=true"
import script from "./TipoConsultaEmpresas.vue?vue&type=script&lang=js"
export * from "./TipoConsultaEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71266fde",
  null
  
)

export default component.exports